import { MixtureComponent } from "../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";

export const getFeedCurveComponentsIds = (mixture?: MixtureComponent[]) => {
  if (!mixture) {
    return [];
  }

  return mixture.map((entry) => entry.component).filter((value, index,  self) => self.indexOf(value) === index);
}